import ScrollToElement from './components/ScrollToElement';

// -----------------------------------------------------------------------------
// Scroll the page to content body by clicking hero cta link
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        new ScrollToElement(element).handleClick();
    }
});



// WEBPACK FOOTER //
// ./js/marketing/bundles.js